<template>
  <el-autocomplete
      size="mini"
      v-model="engagement"
      :placeholder="$t('engagement_search')"
      prefix-icon="el-icon-search"
      :fetch-suggestions="querySearchAsync"
      :trigger-on-focus="false"
      @select="handleSelect"
      style="width: 100%; margin-left: 0">
    <template slot-scope="{ item }">
      <div class="value">{{ item.name }}</div>
    </template>
  </el-autocomplete>
</template>

<script>
import axios from 'axios';
export default {
  name: 'engagementSearchComponent',
  data() {
    return {
      links: [],
      engagement: '',
      timeout:  null
    }
  },
  methods: {
    querySearchAsync(queryString, cb) {
      if(queryString.length >= 3){
        this.loadEngagements(queryString).then(data => {
          // let links = data;
          // let results = queryString ? links.filter(this.createFilter(queryString)) : links;
          cb(data);
        })
      }else{
        cb([])
      }
    },
    loadEngagements(queryString){
      return new Promise((resolve, reject) => {
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios.post(`/api/v1/engagements/search?companyId=${this.$route.query.companyId}&text=${queryString}`)
            .then(response => {
              this.links = response.data.list
              resolve(response.data.list)
            })
            .catch(error => {
              console.log('An error occurred:', error);
              reject(error)
            });
      })
    },
    createFilter(queryString) {
      return (link) => {
        return (link.no.toLowerCase().indexOf(queryString.toLowerCase()) === 0 || link.name.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
      };
    },
    handleSelect(item) {
      this.$router.push(`/engagements?companyId=${this.$route.query.companyId}&engagementId=${item.id}`)
      this.$emit('submit', item.id, 'first')
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/.el-input__prefix {
  left: 0;
}
</style>
